/* eslint-disable camelcase */
import { PlotReportFactElement } from '@/api/rest/resources/types/fact';
import { IndicatorProductSubscriptionConfiguration } from '@/api/rest/resources/types/IndicatorProduct';
import { WidgetSlot, WidgetType } from '@/api/rest/resources/types/widget';
import { usePlotsForOrganization } from '@/pages/shared/hooks/usePlotsForOrganization';
import { isNullish } from '@/utils/booleans';

import { buildIndicatorName, factToDraftItem, MediaMapDraftItem } from '../utils/mediaMapItem';

export const useMediaMapItemsFromFacts = (
  configuration: IndicatorProductSubscriptionConfiguration,
): MediaMapDraftItem[] => {
  const factName = buildIndicatorName(configuration.id);
  const mapWidget = Array.isArray(configuration.widget?.widget_format)
    ? configuration.widget.widget_format.find((w: WidgetSlot) => w.type === WidgetType.o_c_insitu_media_map)
    : undefined;
  const { end_date_inclusive = undefined, start_date_inclusive = undefined } =
    mapWidget?.relatedData?.dateFilters ?? {};
  const sourceRef = configuration.file_info?.[0]?.id;

  const plots =
    usePlotsForOrganization(undefined, {
      fact_names: factName,
      ...(end_date_inclusive ? { end_date_inclusive } : {}),
      ...(start_date_inclusive ? { start_date_inclusive } : {}),
      source_ref: sourceRef,
    }).data?.results ?? [];

  return plots.flatMap((plot) =>
    (plot.facts ?? [])
      .filter((fact): fact is PlotReportFactElement<string> => !isNullish(fact.date))
      .map((fact) => factToDraftItem(plot.name, fact, configuration.id)),
  );
};
